/** Textos do FilterPanel (os mesmos do painel antigo do shared, já removido). */
export const FILTERS_LABEL = "Filtros";
export const FIELD_PLACEHOLDER = "Selecionar filtro";
export const VALUES_PLACEHOLDER = "Selecionar";
export const ADD_FILTER_LABEL = "Adicionar filtro";
export const APPLY_FILTERS_LABEL = "Aplicar";
export const CLEAR_FILTERS_LABEL = "Limpar Filtros";
export const UNDO_CLEAR_LABEL = "Desfazer";
/** Janela do "Desfazer" depois de Limpar (spec "Limpar Filtros e Desfazer" do Figma, 10519:24357). */
export const UNDO_WINDOW_MS = 5000;
export const SAVE_FILTER_LABEL = "Salvar filtro";
export const REMOVE_FILTER_LABEL = "Remover filtro";
export const DELETE_SAVED_FILTER_LABEL = "Excluir filtro salvo";
export const SAVED_FILTERS_PLACEHOLDER = "Filtros Salvos";
export const SAVED_FILTERS_EMPTY_MESSAGE = "Nenhum filtro salvo nesse módulo";
export const COLLAPSE_LABEL = "Recolher filtros";
export const EXPAND_LABEL = "Expandir filtros";
export const FILTER_LOADING_MESSAGE = "Carregando opções...";
export const FILTER_ERROR_MESSAGE = "Não foi possível carregar as opções.";
export const FILTER_EMPTY_MESSAGE = "Nenhuma opção disponível.";
export const FILTER_NO_RESULTS_MESSAGE = "Nenhuma opção encontrada.";
export const INCOMPLETE_ROW_MESSAGE = "Selecione ao menos um valor.";

export const SAVE_DIALOG_TITLE = "Salvar filtro";
export const SAVE_NAME_LABEL = "Nome do filtro";
export const SAVE_DIALOG_DESCRIPTION =
  "Dê um nome para encontrar este conjunto de filtros depois. Ele fica disponível só para você nesse módulo.";
export const SAVE_CONFIRM_LABEL = "Salvar";

export const SAVED_FILTER_NAME_MAX_LENGTH = 50;
export const MAX_SAVED_FILTERS = 10;
export const SAVED_FILTER_NAME_REQUIRED_MESSAGE = "Informe um nome para o filtro.";
export const SAVED_FILTER_NAME_TOO_LONG_MESSAGE = `O nome deve ter no máximo ${SAVED_FILTER_NAME_MAX_LENGTH} caracteres.`;
export const SAVED_FILTER_NAME_DUPLICATE_MESSAGE = "Já existe um filtro salvo com esse nome.";
export const SAVED_FILTER_LIMIT_MESSAGE = `Limite de ${MAX_SAVED_FILTERS} filtros salvos atingido. Exclua um filtro para salvar outro.`;
export const MONTH_RANGE_PLACEHOLDER = "Selecionar período";

export const DATE_MODE_FIXED_LABEL = "Data fixa";
export const DATE_MODE_PERIOD_LABEL = "Período";
export const DATE_PLACEHOLDER = "Selecionar data";
export const DATE_END_PLACEHOLDER = "Data final";
